export default {
  COMPLETE: 11111017,
  FAILED: 11120012,
  NEEDS_TO_BE_SIGNED: 11111036,
  CAHNGE_PAC_NUMBER: 7000006
};
